import { useSelector } from 'react-redux';
import { getBannersByRegionId } from '../../selectors';
import { Carousel as CarouselComponent } from '../../components/Carousel__DEPRECATED';

export function Carousel() {
  const bannersByRegionId = useSelector(getBannersByRegionId);

  return <CarouselComponent banners={bannersByRegionId} testId="MainCarousel" />;
}
